import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth } from "@/components/shared/RequireAuth";
import { PageShell } from "@/components/site/PageShell";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import QuoteWizard from "@/pages/QuoteWizard";
import Book from "@/pages/Book";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Track from "@/pages/Track";
import Roadside from "@/pages/Roadside";
import Legal from "@/pages/Legal";
import AuthPage from "@/pages/AuthPage";
import PortalLayout from "@/pages/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Vehicles from "@/pages/portal/Vehicles";
import Quotes from "@/pages/portal/Quotes";
import Bookings from "@/pages/portal/Bookings";
import Jobs from "@/pages/portal/Jobs";
import Approvals from "@/pages/portal/Approvals";
import Billing from "@/pages/portal/Billing";
import Messages from "@/pages/portal/Messages";
import ChangePassword from "@/pages/portal/ChangePassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminBoard from "@/pages/admin/AdminBoard";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminServices from "@/pages/admin/AdminServices";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminInsurance from "@/pages/admin/AdminInsurance";
import AdminInsuranceDetail from "@/pages/admin/AdminInsuranceDetail";
import AdminInsurers from "@/pages/admin/AdminInsurers";
import { InsurerProvider, RequireInsurer } from "@/context/InsurerContext";
import { InsurerLogin, InsurerSetPassword } from "@/pages/insurer/InsurerAuth";
import InsurerLayout from "@/pages/insurer/InsurerLayout";
import InsurerDashboard from "@/pages/insurer/InsurerDashboard";
import InsurerRequestForm from "@/pages/insurer/InsurerRequestForm";
import InsurerRequests from "@/pages/insurer/InsurerRequests";
import InsurerRequestDetail from "@/pages/insurer/InsurerRequestDetail";

const NotFound = () => <PageShell testId="not-found-page" title="Page not found" intro="That page doesn't exist." />;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/quote" element={<QuoteWizard />} />
          <Route path="/book" element={<Book />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/track" element={<Track />} />
          <Route path="/roadside" element={<Roadside />} />
          <Route path="/roadside-assistance" element={<Roadside />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/portal" element={<RequireAuth><PortalLayout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="billing" element={<Billing />} />
            <Route path="messages" element={<Messages />} />
            <Route path="password" element={<ChangePassword />} />
          </Route>
          <Route path="/admin" element={<RequireAuth staff><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminOverview />} />
            <Route path="board" element={<AdminBoard />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="insurance" element={<AdminInsurance />} />
            <Route path="insurance/:id" element={<AdminInsuranceDetail />} />
            <Route path="insurers" element={<AdminInsurers />} />
          </Route>
          <Route path="/insurer/login" element={<InsurerProvider><InsurerLogin /></InsurerProvider>} />
          <Route path="/insurer/set-password" element={<InsurerSetPassword />} />
          <Route path="/insurer" element={<InsurerProvider><RequireInsurer><InsurerLayout /></RequireInsurer></InsurerProvider>}>
            <Route index element={<InsurerDashboard />} />
            <Route path="request/new" element={<InsurerRequestForm />} />
            <Route path="requests" element={<InsurerRequests />} />
            <Route path="requests/:id" element={<InsurerRequestDetail />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
